import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IDuct {
  ductID: number;
  name: string;
  flowSupplyMin: number;
  flowSupplyMax: number;
  flowSupplyWarn: number;
  flowExtractionMin: number;
  flowExtractionMax: number;
  flowExtractionWarn: number;
  canRightAngled: boolean;
}

export const getDucts = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/Duct', config);
  return response.data;
};
